import { baseApiClient as api } from "../baseService";
export const addTagTypes = ["portal-providers"] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      treatmentPortalsProvidersList: build.query<
        TreatmentPortalsProvidersListApiResponse,
        TreatmentPortalsProvidersListApiArg
      >({
        query: (queryArg) => ({
          url: `/api/treatment-portals/providers/`,
          params: {
            query: queryArg.query,
          },
        }),
        providesTags: ["portal-providers"],
      }),
    }),
    overrideExisting: false,
  });
export { injectedRtkApi as enhancedApi };
export type TreatmentPortalsProvidersListApiResponse =
  /** status 200  */ PortalProvider[];
export type TreatmentPortalsProvidersListApiArg = {
  /** The query to search for providers */
  query: string;
};
export type TreatmentRecordRequestPortalType =
  | "smart_request"
  | "mro"
  | "chartswap";
export type TreatmentRecordTypes =
  | "Bills"
  | "Records"
  | "Facility Records"
  | "Facility Bills"
  | "Radiology"
  | "ER Physician Bills"
  | "Other"
  | "Unknown";
export type PortalRecordType = {
  id: string | string;
  created_at: string;
  modified_at: string;
  original_name?: string | null;
  record_type: TreatmentRecordTypes;
};
export type PortalProvider = {
  id: string | string;
  created_at: string;
  modified_at: string;
  name: string;
  portal: TreatmentRecordRequestPortalType;
  active?: boolean;
  external_id?: string | null;
  site?: string | null;
  website?: string | null;
  phone?: string | null;
  email?: string | null;
  fax?: string | null;
  address_line_1?: string | null;
  address_line_2?: string | null;
  city?: string | null;
  state?: string | null;
  postal_code?: string | null;
  country?: string | null;
  record_types?: PortalRecordType[] | null;
};
export const { useTreatmentPortalsProvidersListQuery } = injectedRtkApi;
